<template>
  <div v-if="body_show">
    <div class="reading">
      <h2>扩展阅读作为精读和略读的补充，可以拓展阅读的范围，扩大读者的视野，便于沟通课内、课外阅读，加强语文与其他学科的联系，使所学的知识网络化、立体化、综合化。</h2>
      <ul class="wail">
        <li v-for="(item,index) in list" v-if="item.href" :key="index">
          <a :href="item.href"><img src="https://themes-cdn.xjy.cn/statics/career/images/hxz.png" /><span>{{item.name}}</span></a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import {
  projectread
} from "@/api/course";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        list: []
      }
    },
    methods: {
      pullData() {
        projectread({
            course_id: this.$route.query.cid,
            project_id: this.$route.query.cpid
          })
          .then((data) => {
            this.body_show = true;
            this.list = data;
            // 神策统计--扩展阅读
            sensors.track('projectWorkbox', {
              course_id: this.$route.query.cid,
              course_name: data.coursename,
              project_id: this.$route.query.cpid,
              project_name: data.projectname,
              workbox_type: "扩展阅读",
              workbox_name: "扩展阅读",
            });
          })

      }
    },
    created() {
      this.pullData();
      shareCon("course",this);
    }
}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.reading {
  padding: changeRem(.6)+px changeRem(.6)+px 0rem;
  h2 {
    color: #EB5032;
    font-size: changeRem(.64)+px;
    padding-bottom: changeRem(1.2)+px;
    text-align: justify;
    line-height: changeRem(.96)+px;
  }
  .wail {
    width: 100%;
    text-align: left;
    li a {
      display: block;
      width: 100%;
      height: 100%;
      color: #999;
      font-size: changeRem(.52)+px;
      margin-bottom: changeRem(.6)+px;
      img {
        width: changeRem(.56)+px;
        vertical-align: middle;
        margin-right: changeRem(.2)+px;
      }
      span {
        border-bottom: 2px solid #999999;
        text-decoration: none;
        color: #333333;
      }
    }
  }
}
</style>
